const LABS_GRID_COLUMNS = "300px 1fr";

export { LABS_GRID_COLUMNS };
